import { Box } from "@mui/material";
import { LoadDocument } from "../loadFile/LoadDocument";
import { LoadImage } from "../loadFile/LoadImage";
import { LoadPublicOffer } from "../loadFile/LoadPublicOffer";
import { Partners } from "../partners/Partners";
import TextAreaDescription from "../textEditor/TextAreaDescription";
import { UiDatetField } from "shared/ui/UiDatePicker/UiDateField";
import { UiTextField } from "shared/ui/UiInputs/UiTextField";
import dayjs from "dayjs";
import { useMarathonTabForm } from "features/createEditMarathon/model/hooks/marathonTabsHooks/useMarathonTabForm";
import { useTranslation } from "react-i18next";
import { EditorState } from "draft-js";
import { Control, useWatch } from "react-hook-form";

export const RuTab = () => {
  const {
    data,
    register,
    appendDocument,
    control,
    setValue,
    removeDocument,
    resetField,
    updatePublickOffer,
    insertPublicOffer,
    appendPublicOffer,
    removePublicOffer,
    appendPartners,
    removePartners,
    fieldsPartners,
    clearErrors,
    replacePublicOffer,
    errors,
  } = useMarathonTabForm();
  const { t } = useTranslation();

  const indexLanguage = 1;
  const languageId = 2; // Russian

  const logo = useWatch({
    control,
    name: `translations.${indexLanguage}.logo`,
  });

  const textValue = useWatch({
    control,
    name: `translations.${indexLanguage}.text`,
  });

  return (
    <Box
      sx={{
        width: "100%",
        typography: "body1",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <UiTextField
        placeholder={t("createMarathon.enterName")}
        label={t("createMarathon.name")}
        error={errors.translations?.[indexLanguage]?.name?.message}
        inputProps={{
          ...register(`translations.${indexLanguage}.name`),
        }}
      />
      <UiDatetField
        minDate={dayjs()}
        control={control as Control<any>}
        placeholder={t("createMarathon.picDate")}
        label={t("createMarathon.date")}
        name="dateEvent"
      />
      <UiTextField
        inputProps={{
          ...register(`translations.${indexLanguage}.place`),
        }}
        placeholder={t("createMarathon.enterPlace")}
        label={t("createMarathon.place")}
        error={errors.translations?.[indexLanguage]?.place?.message}
      />
      <UiTextField
        inputProps={{
          ...register(`translations.${indexLanguage}.startKitMessage`),
        }}
        placeholder={t("createMarathon.enterKitInfo")}
        label={t("createMarathon.kitIncludes")}
        error={errors.translations?.[indexLanguage]?.startKitMessage?.message}
      />
      <LoadImage
        indexLanguage={indexLanguage}
        setValue={setValue}
        languageId={languageId}
      />
      <LoadPublicOffer
        languageId={languageId}
        data={data}
      />
      <TextAreaDescription
        indexLanguage={indexLanguage}
        placeholder={t("createMarathon.enterDesc")}
        handleChange={(editorState: EditorState) => {
          setValue(`translations.${indexLanguage}.text`, editorState);
          clearErrors(`translations.${indexLanguage}.text`);
        }}
        value={textValue}
      />
      <LoadDocument
        append={appendDocument}
        data={data}
        removeDocument={removeDocument}
      />
      <Partners
        control={control}
        indexLanguage={indexLanguage}
        append={appendPartners}
        fields={fieldsPartners}
        data={data}
        register={register}
        remove={removePartners}
      />
    </Box>
  );
};
